"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
const sumBy = (0, ramda_1.curry)((property, objOrArray) => (0, ramda_1.sum)((0, ramda_1.map)((0, ramda_1.prop)(property), (0, ramda_1.values)(objOrArray))));
exports.default = sumBy;
//# sourceMappingURL=sumBy.js.map